<!--
 * @name: 列表卡片
 * @description: 列表卡片
 * @author: May(yingmei.tu@shengyc.com)
 * @Date: 2019-09-05 10:33:33
 * @LastEditTime: 2020-05-29 18:39:20
 -->
<template>
  <div id="report-card-container">
    <div class="head">
      <span>{{ pathOr('--', ['title'], cardData) }}</span>
    </div>
    <div class="driveLine"></div>
    <div class="content">
      <div
        class="content-item"
        v-for="(contentItem, contentIndex) in cardData.GY"
        :key="contentIndex"
      >
        <span class="label-text">{{ pathOr('--', ['label'], contentItem) }}：</span>
        <div class="right-box">
          <span class="content-text">{{ pathOr('--', ['content'], contentItem) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pathOr } from '@/config/Utils';
export default {
  name: 'ReportCard',
  props: {
    cardData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      pathOr: pathOr
    };
  }
};
</script>

<style lang="scss">
@import '../../../assets/style/mixin';
#report-card-container {
  margin: 0 vw(16) vw(8) vw(16);
  background-color: white;
  padding: 0 vw(20);
  border-radius: vw(4);
  .head {
    padding: vw(14) 0 vw(10) 0;
    span {
      @include sc(vw(15), #333333);
    }
  }
  .driveLine {
    height: vw(1);
    border-bottom: vw(1) solid #eeeeee;
    display: flex;
    justify-content: center;
  }
  .content {
    padding: vw(16) 0 vw(6) 0;
    .content-item {
      margin-bottom: vw(10);
      display: flex;
      // align-items: flex-start;
      flex-direction: 'row';
      .right-box {
        width: 70%;
      }
      .label-text {
        color: #999999;
        font-size: vw(14);
      }
      .content-text {
        color: #333333;
        font-size: vw(14);
      }
    }
  }
}
</style>
